import { render, staticRenderFns } from "./PersonalDetailsReview.vue?vue&type=template&id=58465d2c"
import script from "./PersonalDetailsReview.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports